// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bg-base:      #0f1226;
  --bg-surface:   #15182e;
  --bg-elevated:  #1c2030;
  --bg-hover:     #232842;
  --border:        rgba(255, 255, 255, 0.08);
  --border-strong: rgba(255, 255, 255, 0.14);
  --text-primary:   #f1f5f9;
  --text-secondary: #94a3b8;
  --text-muted:     #64748b;
  --accent:       #3b82f6;
  --accent-hover: #60a5fa;
  --accent-cyan:  #06b6d4;
  --accent-sky:   #0ea5e9;
  --accent-grad:  linear-gradient(135deg, #3b82f6, #06b6d4);
  --accent-glow:  rgba(59, 130, 246, 0.25);
  --success:   #22c55e;
  --warning:   #f59e0b;
  --danger:    #f87171;
  --danger-bg: rgba(248, 113, 113, 0.12);
  --radius-sm: 8px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --primary-color:    var(--accent);
  --success-color:    var(--success);
  --warning-color:    var(--warning);
  --error-color:      var(--danger);
  --text-color:       var(--text-primary);
  --border-color:     var(--border);
  --background-color: var(--bg-base);
  --radius:           var(--radius-md);
  --accent-black:     var(--text-primary);
  --accent-hover-old: var(--accent-hover);
}`, "",{"version":3,"sources":["webpack://./src/styles/Tokens.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,0CAA0C;EAC1C,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,yDAAyD;EACzD,wCAAwC;EACxC,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;EACjC,uCAAuC;EACvC,iCAAiC;EACjC,kCAAkC;EAClC,oCAAoC;EACpC,uCAAuC;EACvC,uCAAuC;AACzC","sourcesContent":[":root {\n  --bg-base:      #0f1226;\n  --bg-surface:   #15182e;\n  --bg-elevated:  #1c2030;\n  --bg-hover:     #232842;\n  --border:        rgba(255, 255, 255, 0.08);\n  --border-strong: rgba(255, 255, 255, 0.14);\n  --text-primary:   #f1f5f9;\n  --text-secondary: #94a3b8;\n  --text-muted:     #64748b;\n  --accent:       #3b82f6;\n  --accent-hover: #60a5fa;\n  --accent-cyan:  #06b6d4;\n  --accent-sky:   #0ea5e9;\n  --accent-grad:  linear-gradient(135deg, #3b82f6, #06b6d4);\n  --accent-glow:  rgba(59, 130, 246, 0.25);\n  --success:   #22c55e;\n  --warning:   #f59e0b;\n  --danger:    #f87171;\n  --danger-bg: rgba(248, 113, 113, 0.12);\n  --radius-sm: 8px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n  --primary-color:    var(--accent);\n  --success-color:    var(--success);\n  --warning-color:    var(--warning);\n  --error-color:      var(--danger);\n  --text-color:       var(--text-primary);\n  --border-color:     var(--border);\n  --background-color: var(--bg-base);\n  --radius:           var(--radius-md);\n  --accent-black:     var(--text-primary);\n  --accent-hover-old: var(--accent-hover);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
